import './App.css'
import './fonts/WinterKei.css'
import './fonts/Rubik.css'
import './fonts/Montserrat.css'

import { BrowserRouter, Routes, Route } from 'react-router-dom'

import Display from './Pages/Display'
import Display2v2 from './Pages/Display2v2'
import Dashboard from './Pages/Dashboard'
import LiveGame from './Pages/LiveGame'
import LiveGameOverlay from './Pages/LiveGameOverlay'
import LiveGameDashboard from './Pages/Dashboard/LiveGameDashboard'
import PostGameDashboard from './Pages/Dashboard/PostGameDashboard'
import DraftDashboard from './Pages/Dashboard/DraftDashboard'
import SettingsDashboard from './Pages/Dashboard/Settings'
import BracketDashboard from './Pages/Dashboard/BracketDashboard'
import ConfigEditorDashboard from './Pages/Dashboard/ConfigEditorDashboard'
import CastersDashboard from './Pages/Dashboard/CastersDashboard'
import StatsDashboard from './Pages/Dashboard/StatsDashboard'
import ScheduleDashboard from './Pages/Dashboard/ScheduleDashboard'
import PagesDashboard from './Pages/Dashboard/PagesDashboard'
import DraftDisplay from './Pages/DraftDisplay'
import AltDraftDisplay from './Pages/AltDraftDisplay'
import VmixDocs from './Pages/VmixDocs'

import { QueryClient, QueryClientProvider } from 'react-query'
import BracketDisplay from './Pages/BracketDisplay'
import RoundRobinDisplay from './Pages/RoundRobinDisplay'
import Login from './Pages/Login'
import ProtectedRoute from './components/ProtectedRoute'

const queryClient = new QueryClient()

function App() {
	return (
		<div>
			<QueryClientProvider client={queryClient}>
				<BrowserRouter>
					<Routes>
						<Route path="/login" element={<Login />} />

						<Route
							path="/"
							element={
								<ProtectedRoute>
									<Display />
								</ProtectedRoute>
							}
						/>
						<Route
							path="/2v2"
							element={
								<ProtectedRoute>
									<Display2v2 />
								</ProtectedRoute>
							}
						/>
						<Route
							path="/LiveGame"
							element={
								<ProtectedRoute>
									<LiveGame />
								</ProtectedRoute>
							}
						/>
						<Route
							path="/LiveGameOverlay"
							element={
								<ProtectedRoute>
									<LiveGameOverlay />
								</ProtectedRoute>
							}
						/>
						<Route
							path="/DraftDisplay"
							element={
								<ProtectedRoute>
									<DraftDisplay />
								</ProtectedRoute>
							}
						/>
						<Route
							path="/AltDraftDisplay"
							element={
								<ProtectedRoute>
									<AltDraftDisplay />
								</ProtectedRoute>
							}
						/>
						<Route
							path="/BracketDisplay"
							element={
								<ProtectedRoute>
									<BracketDisplay />
								</ProtectedRoute>
							}
						/>
						<Route
							path="/RoundRobinDisplay"
							element={
								<ProtectedRoute>
									<RoundRobinDisplay />
								</ProtectedRoute>
							}
						/>

						{window.__RUNTIME_CONFIG__.REACT_APP_ENABLE_CONFIG_EDITOR === 'true' ? (
							<Route
								path="/VmixDocs"
								element={
									<ProtectedRoute>
										<VmixDocs />
									</ProtectedRoute>
								}
							/>
						) : (
							<></>
						)}

						<Route
							path="/Dashboard"
							element={
								<ProtectedRoute>
									<Dashboard />
								</ProtectedRoute>
							}>
							{window.__RUNTIME_CONFIG__.REACT_APP_ENABLE_LIVEGAME === 'true' ? <Route path="LiveGame" element={<LiveGameDashboard />} /> : <></>}
							{window.__RUNTIME_CONFIG__.REACT_APP_ENABLE_POSTGAME === 'true' ? <Route path="PostGame" element={<PostGameDashboard />} /> : <></>}
							{window.__RUNTIME_CONFIG__.REACT_APP_ENABLE_DRAFT === 'true' ? <Route path="Draft" element={<DraftDashboard />} /> : <></>}
							{window.__RUNTIME_CONFIG__.REACT_APP_ENABLE_BRACKET === 'true' ? <Route path="Bracket" element={<BracketDashboard />} /> : <></>}
							{window.__RUNTIME_CONFIG__.REACT_APP_ENABLE_CONFIG_EDITOR === 'true' ? <Route path="ConfigEditor" element={<ConfigEditorDashboard />} /> : <></>}
							{window.__RUNTIME_CONFIG__.REACT_APP_ENABLE_CIV_STATS === 'true' ? <Route path="CivStats" element={<StatsDashboard />} /> : <></>}
							{window.__RUNTIME_CONFIG__.REACT_APP_ENABLE_SCHEDULE === 'true' ? <Route path="Schedule" element={<ScheduleDashboard />} /> : <></>}
							<Route path="Casters" element={<CastersDashboard />} />
							<Route path="Pages" element={<PagesDashboard />} />
							<Route path="Settings" element={<SettingsDashboard />} />
						</Route>
					</Routes>
				</BrowserRouter>
			</QueryClientProvider>
		</div>
	)
}

export default App
